<!--
 * @FilePath: /daren-html-source/src/views/Account/components/tab0.vue
 * @Description: 可提现金额
-->
<template>
  <div v-if="!loading">
    <div class="titleBox">
      {{ $t("IncomeReflect.tabZero.Important") }}
    </div>
    <div class="tab0">
      <div class="item" style="height: 44px; align-items: flex-end">
        <div class="itemLeft" style="margin-bottom: 5px">
          {{ $t("IncomeReflect.tabZero.withdrawableAmount") }}
        </div>
        <div class="itemRight">
          <div class="moneyBox">
            <span v-if="lang == 'en'" class="moneyUnit">￥</span>
            <span>{{ $store.state.userInfo.wealth }}</span>
            <span v-if="lang == 'zh' || lang == 'zhhk'" class="moneyUnit"
              >元</span
            >
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">{{ $t("IncomeReflect.tabZero.Payee") }}</div>
        <div class="itemRight">
          <el-select
            class="addplayer"
            style="width: 320px"
            v-model="form.accountId"
            :placeholder="$t('IncomeReflect.tabZero.SelectAPayee')"
            @change="playerChange"
          >
            <el-option
              v-for="item in accountList"
              :key="item.id"
              :label="
                item.income_account +
                ' ' +
                ' ' +
                item.payee_type_label +
                ' ' +
                ' ' +
                item.account_format +
                ' ' +
                ' 剩余年额度 ' +
                ' ' +
                Number(item.yearly_money_total).toLocaleString() +
                '元 ' +
                ' 近30天已提现次数 ' +
                ' ' +
                item.monthly_times_used +
                '次'
              "
              :value="item.id"
            >
              <div class="one">
                <div>
                  <span>{{ item.income_account }}</span
                  >&nbsp;&nbsp; <span>{{ item.payee_type_label }}</span
                  >&nbsp;&nbsp; <span>{{ item.account_format }}</span
                  >&nbsp;&nbsp; <span>剩余年额度</span>&nbsp;&nbsp;
                  <span
                    >{{
                      Number(item.yearly_money_total).toLocaleString()
                    }}元</span
                  >
                </div>
                <div class="right">
                  近30天已提现次数&nbsp;{{ item.monthly_times_used }}次
                </div>
              </div>
            </el-option>
          </el-select>
        </div>
        <div class="itemRight" style="margin-left: 12px">
          <fm-button
            @click="addAccount"
            icon="icon-add"
            :dashed="true"
            plain
            size="medium"
            >{{ $t("IncomeReflect.tabZero.NewPayee") }}</fm-button
          >
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          {{ $t("IncomeReflect.tabZero.CashWithdrawal") }}
        </div>
        <div class="itemRight">
          <el-input
            style="width: 320px"
            v-model="form.money"
            class="padInput"
            @input="handleInput"
            @blur="handleBlur"
            :placeholder="$t('IncomeReflect.tabZero.TextSix')"
          >
          </el-input>
          <div class="unit">{{ $t("IncomeReflect.tabZero.yuan") }}</div>
        </div>
        <el-tooltip
          popper-class="markReferral"
          effect="dark"
          placement="bottom"
        >
          <div slot="content">
            <div>{{ $t("IncomeReflect.tabZero.tooltipSeven") }}{{ $t("IncomeReflect.tabZero.tooltipEight") }}</div>
            <!-- <div>{{ $t("IncomeReflect.tabZero.tooltipEight") }}</div> -->
            <!-- <div>{{ $t("IncomeReflect.tabZero.tooltipNine") }}</div> -->
          </div>
          <img class="markImg" :src="$utils.getPng('referral-three')" alt="" />
        </el-tooltip>
      </div>
      <!-- style="margin-bottom: 36px"  展示 输入框的时候 需要加上margin -->
      <div class="item" :style="dynamicStyle">
        <div class="itemLeft">
          {{ $t("IncomeReflect.tabZero.phoneNumber") }}
        </div>
        <div
          class="itemRight"
          v-if="this.$store.state.userInfo.is_bind_phone == 1"
        >
          <div class="phone">
            {{ userInfo.pcode }}&nbsp;&nbsp;{{ $utils.hidePhone(form.phone) }}
          </div>
        </div>
        <div class="itemRight pcodeBox" v-else>
          <!-- <div class="pcode">{{ userInfo.pcode || '+86' }}</div>
          <el-input
            style="width: 320px"
            :maxlength="11"
            v-model="form.phone"
            :placeholder="$t('IncomeReflect.tabZero.PleasePhone')"
          >
          </el-input> -->
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            clearable
            style="width: 320px"
            :class="phoneCode.length == 0 ? 'noCode' : ''"
            maxlength="11"
          >
            <template slot="prepend">
              <el-select
                v-if="phoneCode.length > 0"
                popper-class="codePopper2"
                v-model="form.pcode"
                placeholder=" "
                class="codeSelect suffixOne"
              >
                <el-option-group label="选择国家或地区">
                  <el-option
                    v-for="item in phoneCode"
                    :key="item.tel_id"
                    :label="item.tel"
                    :value="item.tel"
                  >
                    <div class="valueBox">
                      <span>{{ item.name }}</span>
                      {{ item.tel }}
                    </div>
                  </el-option>
                </el-option-group>
              </el-select>
              <span class="pcode" v-else>+86</span>
            </template>
          </el-input>
          <div class="tit">* {{ $t("IncomeReflect.tabZero.TextFive") }}</div>
        </div>
      </div>
      <div class="item" style="margin-bottom: 52px">
        <div class="itemLeft">
          {{ $t("IncomeReflect.tabZero.VerificationCode") }}
        </div>
        <div class="itemRight">
          <div class="sendCode">
            <el-input
              style="width: 320px"
              v-model="form.qcode"
              :placeholder="$t('IncomeReflect.tabZero.TextThree')"
              @keyup.enter.native="toSendcode()"
              maxlength="6"
              clearable
            >
            </el-input>
            <fm-button
              @click="time == '60' ? toSendcode() : ''"
              :disabled="
                (time == '60' &&
                  form.pcode == '+86' &&
                  form.phone.length == 11) ||
                (time == '60' && form.pcode != '+86' && form.phone.length > 0)
                  ? false
                  : true
              "
              style="margin-left: 12px; width: 108px"
              size="medium"
              >{{
                time == "60"
                  ? $t("IncomeReflect.tabZero.TextFour")
                  : $t("IncomeReflect.tabZero.Sent") + "(" + time + "s)"
              }}</fm-button
            >
            <span
              v-if="time == '60' && isSms && userInfo.pcode == '+86'"
              class="isSmsclass"
              @click="toSendcode2()"
              >未收到验证码？</span
            >
          </div>
        </div>
      </div>
      <div class="item" style="margin-top: 0; margin-bottom: 72px">
        <div class="itemLeft"></div>
        <div class="itemRight">
          <fm-button
            style="width: 164px"
            type="primary"
            round
            size="big"
            @click="getCash()"
            >{{ $t("IncomeReflect.tabZero.WithdrawCashNow") }}</fm-button
          >
        </div>
      </div>
    </div>
    <div class="footerBox">
      <span class="title">{{
        $t("IncomeReflect.tabZero.WithdrawalRules")
      }}</span>
      <span class="content">{{ $t("IncomeReflect.tabZero.TextSeven") }}</span>
      <span class="content">{{ $t("IncomeReflect.tabZero.TextEight") }}</span>
      <span class="content">{{ $t("IncomeReflect.tabZero.TextNine") }}</span>
      <!-- <span class="content">{{ $t("IncomeReflect.tabZero.TextTen") }}</span> -->
    </div>
    <ChangePhoneDiaVue
      ref="ChangePhoneDia"
      :userInfo="userInfo"
      :showChangePhoneFlag="showChangePhoneFlag"
      @handleClose="showChangePhoneFlag = false"
    ></ChangePhoneDiaVue>

    <!-- 添加收款人 -->
    <AddPayee :isShow="showAddpayFlag" @handleClose="showAddpayFlag = false" />
  </div>
</template>

<script>
import AddPayee from "@/components/AddPayee/index.vue";
import ChangePhoneDiaVue from "@/components/ChangePhoneDIa/index.vue";
import {
  getPayeeListAPI,
  sendCodeAPI,
  toCashAPI,
  userInfoAPI,
  getAreaCode,
  confirmPopUp,
} from "@/utils/apiList/user";
export default {
  components: {
    AddPayee,
    ChangePhoneDiaVue,
  },
  data() {
    return {
      keyword: "",
      disabled: false,
      timerA: "",
      time: 60,
      showAddpayFlag: false,
      form: {
        accountId: "",
        money: "",
        phone: "",
        pcode: "+86",
        qcode: "",
        smsid: "",
      },
      accountList: [],
      loading: false,
      userInfo: {},
      showChangePhoneFlag: false,
      lang: "",
      isSms: false,
      phoneCode: [],
      pre_money: {
        pre_min_money: "",
        pre_max_money: "",
        region: "",
        flag: "",
      },
    };
  },
  created() {
    this.lang = localStorage.getItem("lang") ?? "zh";
    this.getUser();
    this.getPayeeList();
    this.getAreaCodeList();
  },
  beforeDestroy() {
    this.time = 60;
    this.timerA && clearInterval(this.timerA);
  },
  computed: {
    dynamicStyle() {
      if (this.$store.state.userInfo.is_bind_phone != 1) {
        return {
          "margin-bottom": "36px",
        };
      }
      return {};
    },
  },
  methods: {
    getAreaCodeList() {
      getAreaCode({
        type: 4,
      }).then((res) => {
        if (res.status == 1) {
          this.phoneCode = res.data.list;
        }
      });
    },
    toSendcode2: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise((resolve) => {
          if (validate == "close") {
            return;
          }
          // if(this.form.pcode != '+86'){
          //   this.$toast('请换绑中国大陆手机号后再试', 3)
          //   return
          // }
          if (this.time != 60) {
            return;
          }
          var reg_tel =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          if (this.form.pcode == "+86" && !reg_tel.test(this.form.phone)) {
            this.$toast("请正确输入手机号", 3);
            return true;
          }
          this.timerA && clearInterval(this.timerA);

          sendCodeAPI({
            pcode: this.form.pcode || "+86",
            phone: this.form.phone,
            captcha_verify: captcha_verify || "",
            lot_number: validate?.lot_number || "",
            captcha_output: validate?.captcha_output || "",
            pass_token: validate?.pass_token || "",
            gen_time: validate?.gen_time || "",
            sms_type: 2,
          })
            .then((res) => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                });
                this.form.smsid = res.data.msgid;
                this.timerA = setInterval(() => {
                  this.minute();
                }, 1000);
                this.$toast(res.msg, 1);

                this.$toast(res.msg, 1);
              } else if (res.status == 90001) {
                resolve({
                  result: false,
                  validate: false,
                });
                this.$toast(res.msg, 2);
                this.$AliCode.handleOpen(this.toSendcode2);
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  "460bf232a926f297be83b8622a637c21",
                  this.toSendcode2
                );
              } else {
                resolve({
                  result: true,
                  validate: true,
                });
                this.$toast(res.msg, 2);
              }
            })
            .catch((err) => {});
        });
      },
      1000,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toSendcode: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise((resolve) => {
          if (validate == "close") {
            return;
          }
          // if(this.form.pcode != '+86'){
          //   this.$toast('请换绑中国大陆手机号后再试', 3)
          //   return
          // }
          if (this.time != 60) {
            return;
          }
          var reg_tel =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          if (this.form.pcode == "+86" && !reg_tel.test(this.form.phone)) {
            this.$toast("请正确输入手机号", 3);
            return true;
          }
          this.timerA && clearInterval(this.timerA);

          sendCodeAPI({
            pcode: this.form.pcode || "+86",
            phone: this.form.phone,
            captcha_verify: captcha_verify || "",
            lot_number: validate?.lot_number || "",
            captcha_output: validate?.captcha_output || "",
            pass_token: validate?.pass_token || "",
            gen_time: validate?.gen_time || "",
            sms_type: 0,
          })
            .then((res) => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                });
                this.form.smsid = res.data.msgid;
                this.timerA = setInterval(() => {
                  this.minute();
                  this.isSms = true;
                }, 1000);
                this.$toast(res.msg, 1);

                this.$toast(res.msg, 1);
              } else if (res.status == 90001) {
                resolve({
                  result: false,
                  validate: false,
                });
                this.$toast(res.msg, 2);
                this.$AliCode.handleOpen(this.toSendcode);
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  "460bf232a926f297be83b8622a637c21",
                  this.toSendcode
                );
              } else {
                resolve({
                  result: true,
                  validate: true,
                });
                this.$toast(res.msg, 2);
              }
            })
            .catch((err) => {});
        });
      },
      1000,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    addAccount() {
      if (
        this.userInfo.is_bind_phone == 0 &&
        this.userInfo.is_income_account == 0
      ) {
        this.$refs.ChangePhoneDia.step = 2;
        this.$refs.ChangePhoneDia.topTit = "绑定手机号";
        this.showChangePhoneFlag = true;
      } else {
        this.showAddpayFlag = true;
      }
    },
    handleBlur(e) {
      if (this.form.accountId == "") {
        this.$toast("请选择收款人", 2);
        return;
      }
      if (parseInt(this.form.money) < this.userInfo.pre_min_money) {
        // 不用封装好的，直接用element的是因为如果有滑块，封装的出不来
        // this.$toast('最低单笔提现金额为：'+this.userInfo.pre_min_money+'元人民币', 2)
        let text =
          "最低单笔提现金额为：" + this.userInfo.pre_min_money + "元人民币";
        this.$message({
          message: text,
          type: "error",
        });
        return;
      }
      if (parseInt(this.form.money) > this.userInfo.pre_max_money) {
        // this.$toast('最高单笔提现金额为：'+this.userInfo.pre_max_money+'元人民币', 2)
        // 不用封装好的，直接用element的是因为如果有滑块，封装的出不来
        let text =
          "最高单笔提现金额为：" + this.userInfo.pre_max_money + "元人民币";
        this.$message({
          message: text,
          type: "error",
        });
        return;
      }
    },
    handleInput(e) {
      this.form.money = this.form.money.replace(/\D/g, "");
    },
    getUser() {
      userInfoAPI()
        .then((res) => {
          if (res.status == 1) {
            this.userInfo = res.data;
            this.form.phone = this.userInfo.phone;
            this.form.pcode = this.userInfo.pcode || "+86";
            this.$store.commit("setAttr", {
              name: "userInfo",
              val: res.data,
            });
            localStorage.setItem("isDaren", res.data.is_rate_flow);
          }
        })
        .catch((err) => {});
    },
    getPayeeList() {
      this.loading = true;
      getPayeeListAPI({ page: 1, limit: 100 }).then((res) => {
        if (res.status == 1) {
          this.accountList = res.data.accountList.list;
          this.loading = false;
        }
      });
    },
    playerChange(item) {
      // 根据选中的 ID 找到完整的对象数据
      const selectedItem = this.accountList.find(
        (items) => items.id == item
      );
      this.form.accountId = item;
      if (selectedItem) {
        // 现在 selectedItem 是完整的对象数据，包含所有属性
        this.pre_money = {
          pre_min_money: selectedItem?.min_amount,
          pre_max_money: selectedItem?.max_amount,
          region: selectedItem?.region,
          flag: selectedItem?.flag,
        };
      }
    },
    getCash: _.debounce(
      function () {
        if (this.form.accountId == "") {
          this.$toast("请选择收款人", 2);
          return;
        }
        if (this.form.money === "") {
          this.$toast("提现金额不能为空", 2);
          return;
        }
        var re = /^[0-9]+$/;
        if (!re.test(this.form.money)) {
          this.$toast("提现金额只能是正整数", 2);
          return;
        }
        if (parseInt(this.form.money) < this.userInfo.pre_min_money) {
          this.$toast(
            "最低单笔提现金额为：" + this.userInfo.pre_min_money + "元人民币",
            2
          );
          return;
        }
        if (parseInt(this.form.money) > this.userInfo.pre_max_money) {
          this.$toast(
            "最高单笔提现金额为：" + this.userInfo.pre_max_money + "元人民币",
            2
          );
          return;
        }
        // if(this.form.pcode != '+86'){
        //   this.$toast('请换绑中国大陆手机号后再试', 3)
        //   return
        // }
        //临时取消提现需要发送验证码的限制
        // if (this.form.qcode === '') {
        //   this.$toast('请输入验证码', 3)
        //   return
        // }
        toCashAPI(this.form)
          .then((res) => {
            if (res.status == 1) {
              this.$toast(res.msg, 1);
              setTimeout(() => {
                // window.location.reload();
                // this.$store.commit("getUserInfoVuex");
                this.getUser();
                this.resert();
              }, 2000);
            } else {
              this.$toast(res.msg, 2);
            }
          })
          .catch((err) => {});
      },
      1000,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    minute: function () {
      this.time = this.time - 1;
      if (this.time == 0) {
        this.time = 60;
        clearInterval(this.timerA);
      }
    },
    resert() {
      this.form = {
        accountId: "",
        money: "",
        phone: this.userInfo.phone,
        pcode: this.userInfo.pcode,
        qcode: "",
        smsid: "",
      };
      this.isSms = false;
      this.time = 60;
      this.timerA && clearInterval(this.timerA);
    },
  },
};
</script>

<style lang="scss" scoped>
.markImg {
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-left: 12px;
  cursor: pointer;
}
::v-deep .codeSelect {
  width: 80px;
  .el-input {
    width: 80px;
    .el-input__inner {
      width: 80px;
      padding-left: 12px !important;
    }
    // .el-input__suffix{
    //   right: 12px !important;
    // }
    .el-select__caret {
      color: #2c2c2c;
      font-weight: bold;
    }
  }
}
::v-deep .suffixOne {
  .el-input__suffix {
    right: 12px !important;
  }
}
::v-deep .noCode {
  .el-input__inner {
    padding-left: 54px !important;
  }
}
.valueBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    margin-right: 20px;
  }
}

.titleBox {
  margin-top: 24px;
  margin-bottom: 40px;
  width: 932px;
  min-height: 40px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  font-weight: 400;
  font-size: 14px;
  // line-height: 20px;
  color: #F53F3F;
  display: flex;
  align-items: center;
  padding: 10px 12px 10px 12px;
}

.tab0 {
  padding: 0px 110px 0 110px;
  font-weight: 400;
  font-size: 16px;
  color: #2c2c2c;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 28px;

    .itemLeft {
      width: 84px;
      text-align: right;

      margin-right: 24px;
    }
    .itemRight {
      position: relative;
      .moneyBox {
        font-weight: 600;
        font-weight: 500;
        font-size: 36px;
        color: #7e72f6;
      }
      ::v-deep .padInput {
        width: 320px;
        .el-input__inner {
          padding-right: 30px;
        }
      }
      .moneyUnit {
        font-weight: 400;
        font-size: 16px;
        color: #2c2c2c;
        margin: 0 4px;
      }

      .tit {
        height: 20px;
        font-weight: 400;
        font-size: 12px;
        color: #f53f3f;
        line-height: 20px;
        position: absolute;
        bottom: -20px;
        left: 0;
        white-space: nowrap;
      }
      .unit {
        position: absolute;
        top: 50%;
        right: 12px;
        font-weight: 400;
        font-size: 14px;
        color: #bdbdbe;
        transform: translateY(-50%);
      }

      .pcode {
        position: absolute;
        top: 50%;
        left: 12px;
        font-weight: 400;
        font-size: 14px;
        z-index: 100;
        transform: translateY(-50%);
      }

      .phone {
        height: 24px;
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
      }
      .sendCode {
        display: flex;
        align-items: center;
        position: relative;
        .isSmsclass {
          position: absolute;
          bottom: -22px;
          height: 20px;
          line-height: 20px;
          cursor: pointer;
          font-size: 12px !important;
          @include font_style(16px, 400, #f53f3f);
        }
      }
    }
    .pcodeBox {
      ::v-deep .btn-prev {
        display: none;
      }
      ::v-deep .el-input .el-input__inner {
        // padding-left: 54px;
      }
      ::v-deep .el-input {
        // width: 320px;
        height: 39px;
        line-height: 39px;
        display: flex;
        align-items: center;
        .el-input__inner {
          padding-left: 70px;
          height: 39px;
          line-height: 39px;
        }
        .el-input-group__prepend {
          border: none;
          box-shadow: none;
          background: transparent;
          position: absolute;
          // padding: 0px 16px 0 12px;
          line-height: 39px;
          height: 39px;
          color: #2c2c2c;
        }
      }
    }
  }
}
.footerBox {
  padding: 16px 24px 16px 20px;
  background: #f9f9f9;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  .title {
    font-weight: 400;
    font-size: 14px;
    color: #2c2c2c;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .content {
    font-weight: 400;
    font-size: 14px;
    color: #8a8b92;
    line-height: 22px;
  }
}
.one {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right {
    margin-left: 41px;
  }
}
</style>
